module.exports = __webpack_public_path__ + "static/media/European_Roulette.4c2af8cd.webp";